import { memo, useContext, useMemo } from "react";
import { SettingsContext } from "../contexts/settings";
import { buildPortalCustomizationCss } from "./build-portal-customization-css";
import { CustomizationContext } from "./customization-context";

export const PortalCustomizationStyleTag = memo(
  function PortalCustomizationStyleTag() {
    const { customization } = useContext(CustomizationContext);
    const settings = useContext(SettingsContext);
    const css = useMemo(
      () =>
        customization
          ? buildPortalCustomizationCss(customization, {
              customFontFamilies: settings?.brandKit?.customFontFamilies,
            })
          : "",
      [customization, settings?.brandKit?.customFontFamilies],
    );
    if (!css) {
      return null;
    }
    return <style>{css}</style>;
  },
);
